import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _unionBy from "lodash/unionBy";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.find.js";
import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

var CfgLentiVDialog = /*#__PURE__*/function (_Vue) {
  _inherits(CfgLentiVDialog, _Vue);

  var _super = _createSuper(CfgLentiVDialog);

  function CfgLentiVDialog() {
    var _this;

    _classCallCheck(this, CfgLentiVDialog);

    _this = _super.apply(this, arguments);
    _this.lente = null;
    _this.errDiamDx = false;
    _this.errDiamSx = false; // alphaDx: number = 0;
    // betaDx: number = 0;
    // alphaSx: number = 0;
    // betaSx: number = 0;

    _this.distPupWarn = false;
    _this.altPupWarn = false;
    _this.sicuroCambioCalibroNaso = false;
    return _this;
  }

  _createClass(CfgLentiVDialog, [{
    key: "configLentiV",
    get: function get() {
      return this.$store.state.configLentiV;
    }
  }, {
    key: "lentiVista",
    get: function get() {
      return this.$store.getters["configurator/lenti/oftLenses"];
    }
  }, {
    key: "modelliLenti",
    get: function get() {
      return _unionBy(this.lentiVista, "U_THE_MODELLO");
    }
  }, {
    key: "lenteVistaDx",
    get: function get() {
      return this.$store.state.configurator.lenteVistaDx;
    }
  }, {
    key: "lenteVistaSx",
    get: function get() {
      return this.$store.state.configurator.lenteVistaSx;
    }
  }, {
    key: "calibro",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.calibro);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "naso",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.naso);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "assi",
    get: function get() {
      var a = [];
      var start = 0;

      do {
        var obj = {
          value: 0,
          text: ""
        };
        obj.value = start;
        obj.text = start.toString();
        a.push(obj);
        start = start + 1;
      } while (start <= 180);

      return a;
    }
  }, {
    key: "semiDist",
    get: function get() {
      var sd = [];
      var start = 15.0;

      do {
        var obj = {
          value: 0,
          text: ""
        };
        obj.value = start;
        obj.text = start.toFixed(1);
        sd.push(obj);
        start = start + 0.5;
      } while (start <= 40);

      return sd;
    }
  }, {
    key: "sfere",
    get: function get() {
      var s = [];
      var start = Math.min.apply(Math, this.lentiVista.map(function (o) {
        return o.U_THE_SFERA;
      }));

      do {
        var obj = {
          value: 0,
          text: ""
        };
        obj.value = start;
        obj.text = start.toFixed(1);
        s.push(obj);
        start = start + 0.25;
      } while (start <= Math.max.apply(Math, this.lentiVista.map(function (o) {
        return o.U_THE_SFERA;
      })));

      return s;
    }
  }, {
    key: "cilindri",
    get: function get() {
      var s = [];
      var start = Math.min.apply(Math, this.lentiVista.map(function (o) {
        return o.U_THE_CILINDRO;
      }));

      do {
        var obj = {
          value: 0,
          text: ""
        };
        obj.value = start;
        obj.text = start.toFixed(1);
        s.push(obj);
        start = start + 0.25;
      } while (start <= Math.max.apply(Math, this.lentiVista.map(function (o) {
        return o.U_THE_CILINDRO;
      })));

      return s;
    }
  }, {
    key: "lentiFiltered",
    get: function get() {
      var _this2 = this;

      return this.lentiFilteredDx.filter(function (d) {
        return _this2.lentiFilteredSx.some(function (r) {
          return r.U_THE_MODELLO == d.U_THE_MODELLO;
        });
      });
    }
  }, {
    key: "lentiFilteredDx",
    get: function get() {
      var _this3 = this;

      // if (this.sferaDx != 0 || this.cilindroDx != 0) {
      //   const fld: Array<Lenses> = this.lentiVista.filter((lf: Lenses) => {
      //     return (
      //       lf.U_THE_SFERA == this.sferaDx && lf.U_THE_CILINDRO == this.cilindroDx
      //     );
      //   });
      //   return fld;
      // } else {
      //   return this.modelliLenti;
      // }
      var fld = this.lentiVista.filter(function (lf) {
        var _this3$sferaDx, _this3$cilindroDx;

        var sferaDx = (_this3$sferaDx = _this3.sferaDx) !== null && _this3$sferaDx !== void 0 ? _this3$sferaDx : 0;
        var cilindroDx = (_this3$cilindroDx = _this3.cilindroDx) !== null && _this3$cilindroDx !== void 0 ? _this3$cilindroDx : 0;
        return (lf.U_THE_SFERA == sferaDx && lf.U_THE_CILINDRO == cilindroDx || lf.U_THE_TRASP_POSITIVA == sferaDx && lf.U_THE_TRASP_NEGATIVA == cilindroDx) && _this3.alphaDx < lf.U_THE_DIAMETRO / 2 && _this3.betaDx < lf.U_THE_DIAMETRO / 2;
      });
      var lenteOk = fld.find(function (el) {
        return _this3.lenteDx ? el.U_THE_MODELLO == _this3.lenteDx.U_THE_MODELLO : false;
      }); // Se la lente non è disponibile dopo aver applicato il filtro, bisogna toglierla

      if (this.lenteDx != null && lenteOk == undefined) {
        this.$store.commit("openCloseDialogErroreLenti", true);
        this.unsetLenses();
      } else {
        // Aggiorna la lente in base ai nuovi filtri
        if (lenteOk) {
          this.lenteDx = lenteOk;
        }
      }

      return fld;
    }
  }, {
    key: "lentiFilteredSx",
    get: function get() {
      var _this4 = this;

      // if (this.sferaSx != 0 && this.cilindroSx != 0) {
      //   const fls: Array<Lenses> = this.lentiVista.filter((lf: Lenses) => {
      //     return (
      //       lf.U_THE_SFERA == this.sferaSx && lf.U_THE_CILINDRO == this.cilindroSx
      //     );
      //   });
      //   return fls;
      // } else {
      //   return this.modelliLenti;
      // }
      var fls = this.lentiVista.filter(function (lf) {
        var _this4$sferaSx, _this4$cilindroSx;

        var sferaSx = (_this4$sferaSx = _this4.sferaSx) !== null && _this4$sferaSx !== void 0 ? _this4$sferaSx : 0;
        var cilindroSx = (_this4$cilindroSx = _this4.cilindroSx) !== null && _this4$cilindroSx !== void 0 ? _this4$cilindroSx : 0;
        return (lf.U_THE_SFERA == sferaSx && lf.U_THE_CILINDRO == cilindroSx || lf.U_THE_TRASP_POSITIVA == sferaSx && lf.U_THE_TRASP_NEGATIVA == cilindroSx) && _this4.alphaSx < lf.U_THE_DIAMETRO / 2 && _this4.betaSx < lf.U_THE_DIAMETRO / 2;
      });
      var lenteOk = fls.find(function (el) {
        return _this4.lenteSx ? el.U_THE_MODELLO == _this4.lenteSx.U_THE_MODELLO : false;
      }); // Se la lente non è disponibile dopo aver applicato il filtro, bisogna toglierla

      if (this.lenteSx != null && lenteOk == undefined) {
        this.$store.commit("openCloseDialogErroreLenti", true);
        this.unsetLenses();
      } else {
        // Aggiorna la lente in base ai nuovi filtri
        if (lenteOk) {
          this.lenteSx = lenteOk;
        }
      }

      return fls;
    }
  }, {
    key: "alphaDx",
    get: function get() {
      // -1 => valore trovato facendo delle prove con la macchina taglia lenti che, probabilmente,
      // tiene conto di alcune tolleranze e spessori che noi non avevamo calcolato
      var a = this.semiDistDx - 1 - this.naso / 2;
      return a > 0 ? a : 0;
    }
  }, {
    key: "betaDx",
    get: function get() {
      var b = this.calibro - this.alphaDx;
      return b > 0 ? b : 0;
    }
  }, {
    key: "alphaSx",
    get: function get() {
      // -1 => valore trovato facendo delle prove con la macchina taglia lenti che, probabilmente,
      // tiene conto di alcune tolleranze e spessori che noi non avevamo calcolato
      var a = this.semiDistSx - 1 - this.naso / 2;
      return a > 0 ? a : 0;
    }
  }, {
    key: "betaSx",
    get: function get() {
      var b = this.calibro - this.alphaSx;
      return b > 0 ? b : 0;
    }
  }, {
    key: "closeConfigLentiV",
    value: function closeConfigLentiV(c) {
      this.$store.commit("openCloseConfigLentiV", c);
    }
  }, {
    key: "unsetLenses",
    value: function unsetLenses() {
      if (this.$store.state.configLentiV) {
        this.lenteDx = null;
        this.lenteSx = null;
      }

      this.lente = null;
      this.$store.commit("resetLentiVista");
    }
  }, {
    key: "closeAndReset",
    value: function closeAndReset() {
      this.$store.commit("resetLentiVista");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
      this.lenteDx = null;
      this.lenteSx = null;
    }
  }, {
    key: "setLens",
    value: function setLens(l) {
      this.lente = l;
      this.lenteDx = this.lentiFilteredDx.filter(function (d) {
        return l.U_THE_MODELLO == d.U_THE_MODELLO;
      })[0];
      this.lenteSx = this.lentiFilteredSx.filter(function (d) {
        return l.U_THE_MODELLO == d.U_THE_MODELLO;
      })[0];
    }
  }, {
    key: "setOftLensesDxModel",
    value: function setOftLensesDxModel(l) {
      this.$store.commit("configurator/setOftLensesDxModel", l);
    }
  }, {
    key: "setOftLensesSxModel",
    value: function setOftLensesSxModel(l) {
      this.$store.commit("configurator/setOftLensesSxModel", l);
    }
  }, {
    key: "resetCfgLenteVistaDx",
    value: function resetCfgLenteVistaDx() {
      this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
    }
  }, {
    key: "resetCfgLenteVistaSx",
    value: function resetCfgLenteVistaSx() {
      this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
    }
  }, {
    key: "conferma",
    value: function conferma() {
      if (this.lenteDx != null && this.lenteSx != null) {
        this.setOftLensesDxModel(this.lenteDx);
        this.setOftLensesSxModel(this.lenteSx);
        this.closeConfigLentiV(false);
      }
    } // annullaMod() {
    //   if (this.lenteVistaDx == null && this.lenteVistaSx == null) {
    //     this.$store.commit("resetLentiVista");
    //   }
    //   this.closeConfigLentiV(false);
    // }

  }, {
    key: "changedSemiDistDx",
    value: function changedSemiDistDx(newV) {
      if (newV) {
        if (this.semiDistDx + this.semiDistSx < 46 && this.semiDistDx != 0 && this.semiDistSx != 0) {
          this.distPupWarn = true;
        }
      }
    }
  }, {
    key: "changedSemiDistSx",
    value: function changedSemiDistSx(newV) {
      if (newV) {
        if (this.semiDistDx + this.semiDistSx < 46 && this.semiDistDx != 0 && this.semiDistSx != 0) {
          this.distPupWarn = true;
        }
      }
    }
  }, {
    key: "changedLentiFilteredDx",
    value: function changedLentiFilteredDx(newV) {
      if (newV.length == 0) {
        this.$store.commit("resetLentiVista");
      }
    }
  }, {
    key: "changedLentiFilteredSx",
    value: function changedLentiFilteredSx(newV) {
      if (newV.length == 0) {
        this.$store.commit("resetLentiVista");
      }
    }
  }]);

  return CfgLentiVDialog;
}(Vue);

__decorate([Watch("semiDistDx")], CfgLentiVDialog.prototype, "changedSemiDistDx", null);

__decorate([Watch("semiDistSx")], CfgLentiVDialog.prototype, "changedSemiDistSx", null);

__decorate([Watch("lentiFilteredDx")], CfgLentiVDialog.prototype, "changedLentiFilteredDx", null);

__decorate([Watch("lentiFilteredSx")], CfgLentiVDialog.prototype, "changedLentiFilteredSx", null);

CfgLentiVDialog = __decorate([Component({
  computed: {
    lenteSx: {
      get: function get() {
        return this.$store.state.lenteSx;
      },
      set: function set(value) {
        this.$store.commit("setLenteSx", value);
      }
    },
    lenteDx: {
      get: function get() {
        return this.$store.state.lenteDx;
      },
      set: function set(value) {
        this.$store.commit("setLenteDx", value);
      }
    },
    sferaDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.sferaDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setSferaDx", value);
      }
    },
    sferaSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.sferaSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setSferaSx", value);
      }
    },
    cilindroDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.cilindroDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setCilindroDx", value);
      }
    },
    cilindroSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.cilindroSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setCilindroSx", value);
      }
    },
    asseDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.asseDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAsseDx", value);
      }
    },
    asseSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.asseSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAsseSx", value);
      }
    },
    semiDistDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.semiDistDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setSemiDistDx", value);
      }
    },
    semiDistSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.semiDistSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setSemiDistSx", value);
      }
    },
    altPupDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.altPupDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAltPupDx", value);
      }
    },
    altPupSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.altPupSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAltPupSx", value);
      }
    },
    addDx: {
      get: function get() {
        return this.$store.state.configurator.lenti.addDx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAddDx", value);
      }
    },
    addSx: {
      get: function get() {
        return this.$store.state.configurator.lenti.addSx;
      },
      set: function set(value) {
        this.$store.commit("configurator/lenti/setAddSx", value);
      }
    }
  }
})], CfgLentiVDialog);
export default CfgLentiVDialog;